const HisRecentDocuments = ({ color, sx }) => {
  const strokeColor = color ?? "#708FBB";
  const _sx = sx ?? {};
  return (
    <svg
      style={_sx}
      width="32"
      height="31"
      viewBox="0 0 32 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.49997 26.5737H3.99999C3.20434 26.5737 2.44128 26.2567 1.87868 25.6924C1.31607 25.1282 1 24.3629 1 23.565V4.00867C1 2.3539 2.34999 1 3.99999 1H9.89496C10.3891 1.00256 10.8749 1.12749 11.3093 1.36369C11.7437 1.59988 12.1132 1.94003 12.385 2.3539L13.6149 4.1591C13.8867 4.57297 14.2562 4.91312 14.6906 5.14931C15.125 5.38551 15.6108 5.51044 16.1049 5.513H27.9999C28.7955 5.513 29.5586 5.82998 30.1212 6.39422C30.6838 6.95845 30.9999 7.72372 30.9999 8.52167"
        stroke={strokeColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.903 29.5248C26.9279 29.5248 31.0013 25.4513 31.0013 20.4264C31.0013 15.4016 26.9279 11.3281 21.903 11.3281C16.8781 11.3281 12.8047 15.4016 12.8047 20.4264C12.8047 25.4513 16.8781 29.5248 21.903 29.5248Z"
        stroke={strokeColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.1465 17.7207V20.6715L23.6219 22.1469"
        stroke={strokeColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default HisRecentDocuments;
